<template>
  <el-row v-loading="loading">
    <el-col
      :span="24"
      class="left_text_align padding_5px_top padding_10px_bottom"
    >
      <el-tabs
        id='riskTab'
        v-model="activeName"
      >
        <el-tab-pane
          label="基金风险等级分布"
          name="first"
        >
          <el-row>
            <el-col
              :span="24"
              id="latestRisk"
              class="width-950-important height-350"
            ></el-col>
          </el-row>
          <el-row
            class="width-950-important"
            style="margin-top:5px;"
          >
            <el-col
              :span="13"
              class="fund_total_number"
            >合计：{{fundTotalNumber}}只基金</el-col>
            <el-col
              :span="11"
              class="risk_date right_text_align"
            >截止日期：{{latestRiskDate}}</el-col>
          </el-row>
          <el-row class="width-950-important">
            <el-col
              :span="13"
              class="fund_total_number"
            >注：不包含已经清算的基金。</el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane
          label="基金风险画像"
          name="second"
        >
          <el-row>
            <el-col
              :span="24"
              id="marketRiskPortrait"
              class="width-950-important height-350"
            >
            </el-col>
            <!--el-col class="padding-bottom-30"></el-col-->
          </el-row>
          <el-row
            class="width-950-important"
            style="margin-top: 5px;"
          >
            <el-col
              :span="13"
              class="fund_total_number"
            >注：最大回撤期间为5年</el-col>
            <el-col
              :span="11"
              class="risk_date right_text_align"
            >截止日期：{{marketRiskPortraitDate}}</el-col>
          </el-row>
        </el-tab-pane>

        <el-tab-pane
          label="风险等级变动占比(一年)"
          name="third"
        >
          <el-row>
            <el-col
              :span="24"
              id="riskAdjustmentChart"
              class="width-950-important height-350"
            >
            </el-col>
          </el-row>
        </el-tab-pane>

        <el-tab-pane
          label="当月风险等级变动原因分布"
          name="fourth"
        >
          <el-row style="margin-top:-10px;">
            <el-col
              :span="24"
              class="width-950-important"               
            >
              <el-table
                :data="tableData"
                :default-sort="{ prop: 'riskIncreasing', order: 'descending' }"
                style="width: 100%;"
              >
                <el-table-column
                  fixed
                  type="index"
                  label="序号"
                  width="50"
                ></el-table-column>
                <el-table-column
                  fixed
                  prop="adjustmentType"
                  label="变动原因"
                  width="400"
                >
                </el-table-column>
                <el-table-column
                  fixed
                  prop="riskIncreasing"
                  label="风险上升"
                  width="250"
                >
                </el-table-column>
                <el-table-column
                  prop="riskDecreasing"
                  label="风险下降"
                  width="250"
                >
                </el-table-column>
              </el-table>
              <el-row :gutter="50">
                <el-col
                  class="risk_adjustment_item"
                  :span="11"
                >当期全市场基金数量：</el-col>
                <el-col
                  class="risk_adjustment_data"
                  :span="5"
                >{{tableFundSize}}</el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col
                  class="risk_adjustment_item"
                  :span="11"
                >当期风险等级变动数量：</el-col>
                <el-col
                  class="risk_adjustment_data"
                  :span="5"
                >{{adjustmentSize}}</el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col
                  class="risk_adjustment_item"
                  :span="11"
                >变动比例：</el-col>
                <el-col
                  class="risk_adjustment_data"
                  :span="5"
                >{{adjustmentRate}}%</el-col>
              </el-row>
              <el-row style="margin-top:10px;">
                <el-col
                  :span="11"
                  class="risk_date"
                >截止日期：{{RiskAdjustmentTableDate}}</el-col>
              </el-row>
            </el-col>

          </el-row>
        </el-tab-pane>
      </el-tabs>

    </el-col>
  </el-row>
</template>
<script>
import { Message } from "element-ui";
import {
    getRiskPortrait,
    getRiskAdjustmentTable,
    getRiskAdjustmentChart
} from "../../api/suitability";

const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;
const latestRiskChart=componentsCommon.riskPortrait.latestRiskChart;
const marketRiskPortraitChart=componentsCommon.riskPortrait.marketRiskPortraitChart;
const riskAdjustmentChart=componentsCommon.riskPortrait.riskAdjustmentChart;

export default {
    data() {
        return {
            activeName: "first",
            latestRiskDate: "",
            marketRiskPortraitDate: "",
            RiskAdjustmentChartDate: "",
            RiskAdjustmentTableDate: "",
            loading: "",
            fundTotalNumber: 0,
            tableData: [],
            tableFundSize: 0,
            adjustmentSize: 0,
            adjustmentRate: 0
        };
    },
    watch: {
        activeName: function(name) {
            let self = this;
            switch (name) {
                case "first":
                case "second":
                    self.loadingData();
                    break;
                case "third":
                    self.getRiskAdjustmentChart();
                    break;
                case "fourth":
                    self.getRiskAdjustmentTable();                    
                    break;
            }
        }
    },
    methods: {
        loadingData() {
            let self = this;
            self.loading = true;
            let para = "latestVersion=1";
            getRiskPortrait(para)
                .then(response => {
                    let jsonData = response.data;
                    if (jsonData == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(jsonData, self)) {
                            let result = jsonData.data;
                            self.latestRiskDate = result.effectiveDate;
                            self.marketRiskPortraitDate = result.effectiveDate;
                            self.fundTotalNumber = result.fundTotalNumber;
                            switch (self.activeName) {
                                case "first":
                                    latestRiskChart(
                                        result.riskPortrait.totalRisk,
                                        result.riskPortrait.fundCount,
                                        "最新基金风险等级数量分布",
                                        "#latestRisk",
                                        result.riskPortrait.maxY
                                    );
                                    break;
                                case "second":
                                    marketRiskPortraitChart(
                                        result.riskPortrait,
                                        "#marketRiskPortrait",
                                        result.riskPortrait.minYRiskPortrait,
                                        result.riskPortrait.maxYRiskPortrait
                                    );
                            }
                        }
                    }
                    self.loading = false;
                })
                .catch(err => {
                    self.loading = false;
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                    console.log(err);
                })
                .finally(r => {
                    self.loading = false;
                });
        },
        getRiskAdjustmentChart() {
            let self = this;
            self.loading = true;
            getRiskAdjustmentChart()
                .then(response => {
                    let jsonData = response.data;
                    if (jsonData == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(jsonData, self)) {
                            let result = jsonData.data;
                            riskAdjustmentChart(
                                "#riskAdjustmentChart",
                                result.riskAdjustmentChart
                            );
                        }
                    }
                    self.loading = false;
                })
                .catch(err => {
                    self.loading = false;
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                    console.log(err);
                })
                .finally(r => {
                    self.loading = false;
                });
        },
        getRiskAdjustmentTable() {
            let self = this;
            self.loading = true;
            getRiskAdjustmentTable()
                .then(response => {
                    let jsonData = response.data;
                    if (jsonData == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(jsonData, self)) {
                            let result = jsonData.data;
                            var tempArray =
                                result.fundRiskAdjustmentDetailList;                              
                            // var ArrTableDate =new Array();
                            // for (var i=0 ; i < tempArray.length ;i++){
                            //   ArrTableDate[i] = tempArray[i];
                            // }
                            // tempArray[7]=ArrTableDate[0];
                            // tempArray[2]=ArrTableDate[1];
                            // tempArray[0]=ArrTableDate[2];                           
                            // tempArray[1]=ArrTableDate[3];
                            // tempArray[4]=ArrTableDate[4];
                            // tempArray[3]=ArrTableDate[5];
                            // tempArray[5]=ArrTableDate[6];
                            // tempArray[6]=ArrTableDate[7];
                            self.tableData = tempArray;
                            self.RiskAdjustmentTableDate = result.effectiveDate;
                            self.tableFundSize = result.totalSize;
                            self.adjustmentRate = (
                                result.adjustmentRate * 100
                            ).toFixed(2);
                            self.adjustmentSize = result.adjustmentSize;
                        }
                    }
                    self.loading = false;
                })
                .catch(err => {
                    self.loading = false;
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                    console.log(err);
                })
                .finally(r => {
                    self.loading = false;
                });
        }
    }
};
</script>
<style lang="scss">
@import "../../public/sass/components/riskPortrait";
</style>